(($) => {

    $.fn.formEnvoy = function () {
        /*
        Toggles a label element's active class
        depending on its corresponding input. In particular,
        the form envoy label is active iff has focus or has a non-empty value.
         */
        const className = 'active';

        return this.each((i, el) => {
            const envoy = $(el);
            const inputId = envoy.attr('for');
            const input = $('#' + inputId);
            const handler = () => {
                if (input.hasClass('dynamic') || input.val() || input[0] === document.activeElement) {
                    envoy.addClass(className);
                }
                else {
                    envoy.removeClass(className);
                }
            };
            const delayedHandler = () => setTimeout(handler, 100);
            /*
            TRICKY
            delaying blur handler fixes issue with lag between selecting dropdown item and setting input value
             */
            input
                .on('change', handler)
                .on('focus', handler)
                .on('blur', delayedHandler)
            ;
            handler();
        });

    };

})(jQuery);
